(() => {
  'use strict';
  if (window.ctCartRewardLoaded) return;
  window.ctCartRewardLoaded = true;
  const duration = 10 * 60 * 1000;
  const timerKey = 'ct-cart-countdown-v3';
  const memory = new Map();
  function read(key) {
    try { return localStorage.getItem(key) || memory.get(key); } catch (_) { return memory.get(key); }
  }
  function write(key, value) {
    memory.set(key, value);
    try { localStorage.setItem(key, value); } catch (_) {}
  }
  function remove(key) {
    memory.delete(key);
    try { localStorage.removeItem(key); } catch (_) {}
  }
  function update() {
    const banner = document.querySelector('[data-ct-cart-reward]');
    if (!banner) return null;
    const drawer = banner.closest('cart-drawer');
    const wait = banner.querySelector('[data-ct-reward-wait]');
    const offer = banner.querySelector('[data-ct-reward-offer]');
    const appliedNote = banner.querySelector('[data-ct-reward-applied]');
    banner.dataset.ready = 'false';
    wait.hidden = offer.hidden = appliedNote.hidden = true;
    if (!drawer || drawer.classList.contains('is-empty')) {
      remove(timerKey);
      banner.hidden = true;
      return null;
    }
    const now = Date.now();
    const expiry = Date.parse(banner.dataset.expires);
    const valid = banner.dataset.offerEnabled === 'true' && Boolean(banner.dataset.code) && Number.isFinite(expiry) && now < expiry;
    const earnedKey = 'ct-cart-reward-earned-v1:' + banner.dataset.code + ':' + banner.dataset.expires;
    const applied = valid && banner.dataset.applied === 'true';
    let earned = valid && read(earnedKey) === 'true';
    if (applied || earned) {
      write(earnedKey, 'true');
      banner.hidden = false;
      appliedNote.hidden = !applied;
      offer.hidden = applied;
      banner.dataset.ready = String(!applied);
      return applied ? null : banner;
    }
    let start = Number(read(timerKey));
    if (!(start > 0 && start <= now)) {
      if (!drawer.classList.contains('active')) { banner.hidden = true; return null; }
      start = now;
      write(timerKey, String(start));
    }
    const remaining = Math.max(0, Math.ceil((start + duration - now) / 1000));
    earned = remaining === 0 && valid;
    if (earned) write(earnedKey, 'true');
    banner.hidden = remaining === 0 && !earned;
    banner.dataset.ready = String(earned);
    wait.hidden = remaining === 0;
    offer.hidden = !earned;
    const clock = banner.querySelector('[data-ct-reward-clock]');
    const time = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0');
    if (clock.textContent !== time) clock.textContent = time;
    return earned ? banner : null;
  }
  document.addEventListener('click', (event) => {
    if (!event.target.closest('#CartDrawer-Checkout, [data-ct-reward-claim]')) return;
    const banner = update();
    if (!banner) {
      if (event.target.closest('[data-ct-reward-claim]')) event.preventDefault();
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(banner.querySelector('[data-ct-reward-claim]').href);
  }, true);
  document.addEventListener('visibilitychange', update);
  window.addEventListener('storage', update);
  window.setInterval(update, 1000);
  update();
})();
